import { combineReducers } from '@reduxjs/toolkit';
import discount from './discountSlice'

const discountReducer = combineReducers({
    discount
});

export default discountReducer;